import { GeminiUsageLevelEnum } from '@workalizer/shared/enums';
import { GEMINI_USAGE_LEVELS } from '@workalizer/shared/lib/gemini-usage-level';
import { getPercentageDiff, randomInt, toPercent } from '@workalizer/shared/utils';
export var geminiSummary = function (_input) {
    var usersInScope = 204;
    var activeUsers = randomInt(150, 180);
    var previousActiveUsers = randomInt(130, 170);
    var actions = randomInt(15000, 22000);
    var previousActions = randomInt(13000, 20000);
    var standaloneShare = randomInt(18, 26);
    var previousStandaloneShare = randomInt(18, 26);
    var standaloneActions = Math.round((actions * standaloneShare) / 100);
    var avgActionsPerUser = Math.round(actions / activeUsers);
    var previousAvgActionsPerUser = Math.round(previousActions / previousActiveUsers);
    var levelCounts = GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
        acc[level] = randomInt(10, 60);
        return acc;
    }, {});
    var levelTotal = Object.values(levelCounts).reduce(function (sum, count) { return sum + count; }, 0);
    var previousLevelCounts = GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
        acc[level] = randomInt(10, 60);
        return acc;
    }, {});
    return {
        usersInScope: usersInScope,
        totalActions: {
            count: actions,
            previous: getPercentageDiff(previousActions, actions)
        },
        adoptionRate: {
            count: activeUsers,
            share: toPercent(activeUsers, usersInScope),
            previous: getPercentageDiff(previousActiveUsers, activeUsers)
        },
        avgActionsPerUser: {
            count: avgActionsPerUser,
            previous: getPercentageDiff(previousAvgActionsPerUser, avgActionsPerUser)
        },
        standaloneInAppUsage: {
            left: {
                share: standaloneShare,
                count: standaloneActions,
                previous: getPercentageDiff(previousStandaloneShare, standaloneShare)
            },
            right: {
                share: 100 - standaloneShare,
                count: actions - standaloneActions,
                previous: getPercentageDiff(100 - previousStandaloneShare, 100 - standaloneShare)
            }
        },
        usageLevel: {
            period: {
                isValid: true,
                weekCount: 12,
                effectiveDateFrom: '2026-01-01',
                effectiveDateTo: '2026-03-25'
            },
            level: GeminiUsageLevelEnum.MEDIUM,
            previousLevel: GeminiUsageLevelEnum.LOW,
            distribution: GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
                acc[level] = {
                    count: levelCounts[level],
                    share: toPercent(levelCounts[level], levelTotal),
                    previous: getPercentageDiff(previousLevelCounts[level], levelCounts[level])
                };
                return acc;
            }, {})
        }
    };
};
